import $ from '../$';
import { JQ } from '../JQ';
$.fn.slice = function (...args) {
    return new JQ([].slice.apply(this, args));
};
